/**
 * flagOptions defines all possible values for each feature flag.
 * This is the source of truth for flag configuration.
 */
export const flagOptions = {
  // When a flag is added here it should reference its removal ticket.
  // ex. "docupload-preview": [true, false] as const, // removal HC-123
  "doc-upload-redesign-use-legacy-message-keys": [true, false] as const, // removal HC-154
  "doc-upload-may24": ["default", "control", "checkbox-requirements", "doc-type-icons"] as const,
  "include-cvec-field-france-student": [
    "default",
    "control",
    "labeled-optional",
    "not-labeled-optional",
  ] as const, // removal HC-736
  "doc-upload-considerations": ["default", "control", "add-doc-considerations"] as const,
  "org-selected-display": ["default", "control", "box-display"] as const,
  "org-search-overlay": ["default", "control", "overlay"] as const,
  "hc-open-org-warning": ["control", "warning-orange", "warning-gray"] as const,
  "hc-my-sheer-id-theme-builder": [true, false] as const, // removal HC-1623
  "hc-success-page-compact-spacing": [true, false] as const, // removal HC-1723
} as const;

/**
 * Flags type is generated from flagOptions to ensure consistency.
 */
export type Flags = {
  [K in keyof typeof flagOptions]: (typeof flagOptions)[K][number];
};

/**
 * These are flag defaults they are passed into the LD flag provider and
 * populate the provider before LD's responses come back.
 */
export const flagDefaults: Flags = {
  "doc-upload-redesign-use-legacy-message-keys": false,
  "doc-upload-may24": "default",
  "include-cvec-field-france-student": "default",
  "doc-upload-considerations": "default",
  "org-search-overlay": "default",
  "org-selected-display": "default",
  "hc-open-org-warning": "control",
  "hc-my-sheer-id-theme-builder": false,
  "hc-success-page-compact-spacing": false,
};

export type FlagNames = keyof Flags;
